import React from 'react'
import './Photo.css'

const Photo = () => {
  return (
    <div className='Photo'>
      <div className='Photo_img'></div>
    </div>
  )
}

export default Photo